/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { AvailabilitySettings, CalProvider } from "@calcom/atoms";
import { useDispatch } from "react-redux";
import "@calcom/atoms/globals.min.css";
import { getCalToken } from "../../../store/calendlySlice";
import { APIS, getUserId } from "../../../utils/constants";

function MyAvailability(props) {
    const { specificUser = false } = props;

    const dispatch = useDispatch();
    const [availabilityToken, setToken] = useState("");

    useEffect(() => {
        const refreshToken = (token) => setToken(token);
        let param = false; 
        if(specificUser){
            param = `?mentor_user_id=${specificUser}`
        }
        dispatch(getCalToken(param, refreshToken));
    }, []);

    return (
        <>
            {availabilityToken && (
                <CalProvider
                    accessToken={availabilityToken}
                    clientId={process.env.REACT_APP_CAL_CLIENT_ID}
                    options={{
                        apiUrl: 'https://api.cal.com/api/v2',
                        refreshUrl: `${APIS.REFRESH_TOKEN}?mentor_user_id=${getUserId()}`
                    }}
                >      <main className={`flex min-h-screen flex-col`}>
                        <div>
                            <AvailabilitySettings
                                travelSchedules={"getTravelSchedules"}
                                isDefault
                                timeZone={Intl.DateTimeFormat().resolvedOptions().timeZone}
                                enableOverrides={true}
                                customClassNames={{
                                    subtitlesClassName: "hiddenCC text-black-300",
                                    ctaClassName: "border p-4 rounded-md",
                                    editableHeadingClassName: "hiddenCC none font-semibold",
                                    formClassName: "collageContactAvailability"
                                }}
                            />
                        </div>
                    </main>
                </CalProvider>
            )}
        </>
    );
}

export default MyAvailability;
